export default {
	inserted(el, binding) {
		el.addEventListener('click', () => {
			if (!el.disabled) {
				el.disabled = true;
				el.style.opacity = '0.6';
				el.style.cursor = 'not-allowed';

				setTimeout(() => {
					el.disabled = false;
					el.style.opacity = '1';
					el.style.cursor = 'pointer';
				}, binding.value || 2000); // 默认2秒后恢复
			}
		});
	}
};
